if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}
// Func = limiting Scope for this file
var lastScrollTop = 0

//vanilla variables for resizing
var w = window,
	d = document,
	e = d.documentElement,
	g = d.getElementsByTagName('body')[0],
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight

resizeWindow()

;(function () {

	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	// burger menu funcionality
	const ctaburgerMenu = document.querySelectorAll('.burger-menu-js')
	const burgerMenu = document.querySelector('.burger-section-js')
	ctaburgerMenu.forEach((cta) => {
		cta.addEventListener('click', (e) => {
			e.preventDefault()
			burgerMenu.classList.toggle('open')
			document.body.classList.toggle('no-scroll')
		})
	})

	//subnavigation submenu
	const menu_Items = document.querySelectorAll(".burger-section-js .privary-navigation li:has(.submenu)");
	let prevMenuItem;
	menu_Items.forEach( element => {
		const Main_Link = element.querySelector("a");
		element.classList.add("has-sub")
		Main_Link.addEventListener('click', (e) =>{
			e.preventDefault();
			if (prevMenuItem && prevMenuItem != e.target.nextElementSibling) prevMenuItem.classList.remove('active');
			e.target.nextElementSibling.classList.toggle("active");
			prevMenuItem = e.target.nextElementSibling;
		});
	});

	// accordion Funcionality
	let acordionitems = document.querySelectorAll('.accordion-js h2')
	acordionitems.forEach((item) => {
		item.addEventListener('click', (element) => {
			element.target.classList.toggle('active')
			element.target.nextElementSibling.classList.toggle('active')
		})
	})

	// cards Funcionality
	let cards_container = document.querySelector('.two-cards__content, .two-cards')
	if (cards_container) {
		let cards_images = document.querySelectorAll('[data-img]')
		let cards__content = document.querySelectorAll('[data-content]')

		cards_images.forEach((element) => {
			element.addEventListener('mouseover', function (item) {
				cards_images.forEach((remove) => remove.classList.add('inactive'))
				cards_images.forEach((remove) => remove.classList.remove('open'))
				cards__content.forEach((remove) => remove.classList.remove('active'))
				this.classList.remove('inactive')
				this.nextElementSibling.classList.add('active')
				if (this.nextElementSibling.classList.contains('active')) {
					this.classList.add('open')
				}
			})
		})

		cards_container.addEventListener('mouseout', function(e) {
			if (e.target === this) {
				cards_images.forEach(remove => remove.classList.remove("open","inactive"));
				cards__content.forEach(remove => remove.classList.remove("active"));
			}
		});
	}

	//For Menu Tabs
	document.querySelectorAll('[data-filter]').forEach((btn, i) => {
		btn.addEventListener('click', e => {
			e.preventDefault()
				document.querySelectorAll('[data-filter]').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('[data-section]').forEach(menu => {
						menu.classList.remove('active');
						if (btn.dataset.filter === menu.dataset.section ) {
							menu.classList.add('active');
						}
				});
		});
	});

	// Header Logo Offset
	document.getElementById("header").style.setProperty('--offset', `${document.getElementById("header").querySelector('.logo').parentElement.offsetLeft}px`);

	//Nav parent active primary menu desktop
	let item = document.querySelector('.privary-navigation__submenu .active')
	if (item != undefined) {
		let itemSubmenu =
			item.parentElement.parentElement.parentElement.firstElementChild
		itemSubmenu.classList.add('active')
	}

	// Header missing top content
	if (document.querySelector("#top-content") == null) {
		document.querySelector("#header").classList.add("scroll")
	}

	//Remove function click
	document.querySelectorAll('.no-click-js').forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault()
		})
	})

	//Email signup animation
	const allInputsSignUp = document.querySelectorAll('.email-signup .input input');
	if (allInputsSignUp) {
		allInputsSignUp.forEach((input) => {
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved')
			})
		})
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field')

		for (let j = 0; j < allffields.length; j++) {
			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
						allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function () {
							this.parentElement.classList.add('moved')
						})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
		}
	}

	/* Subnav on mobile */
	let submenuHold = document.querySelectorAll('#content .sub-menu__hold')
	let allsublinks = document.querySelectorAll('#content .sub-menu a')
	if (allsublinks.length > 1) {
		allsublinks.forEach((ele) => {
			ele.addEventListener('click', function (ev) {
				if (ele.classList.contains('active')) {
					ev.preventDefault()
				}
			})
		})
		let toggleBtn = document.querySelector('.sub-menu__toggle')
		if (toggleBtn) {
			//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
			toggleBtn.addEventListener('click', function () {
				toggleBtn.parentElement.classList.toggle('open')
			})
		}
	} else if (submenuHold.length > 0) {
		submenuHold[0].classList.add('hidden')
	}

	//class for scroll
	let classtoscroll = document.querySelectorAll(".scroll-js , .btn-scroll");
	if (classtoscroll) {
		classtoscroll.forEach(item =>{
			item.addEventListener("click", (e)=>{
				e.preventDefault();
				let sectiongoto = e.target.hash.split("#")[1];
				animateTo(sectiongoto)
			});
		});
	}

	/* Specials Columns Module */
	if( document.querySelector(`.js-specialsCol`) )
		specialOnColumns();
})()

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up')
			document.getElementById('header').classList.remove('down')
		}
	}

	if (document.querySelector('.sitemap , .terms-and-conditions , #gallery-category, #attractions')) {
		document.getElementById('header').classList.add('up')
	}

	lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
}

function resizeWindow() {
	//calculate a new window size
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight

	//header image to be window height on homepage
	if (
		document.getElementsByClassName('img-slide').length > 0 ||
		document.querySelector('#home.home-page') != null
	) {
		let headerImages = document.getElementsByClassName('img-slide')
		let headerImagesLength = headerImages.length
		for (let i = 0; i < headerImagesLength; i++) {
			headerImages[i].style.height = windowHeight + 10 + 'px'
		}
	}
}

//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 100
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1800
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)
	}, 1000 / 60)

	window.scrollTo(0, from)
}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft,
	}
}

function scrollToElementFn( element ){
	if( !element ) return false;

	element.scrollIntoView({ 
		behavior: "smooth", 
		block: "center"
	});
	/*
		* The properties used for the parameter 'block' it's for indicate where the section found should be respect the screen 'start, center, end'
	*/
}

function getAndMountSpecialsOnColumns({ tag, container }){
	tag = encodeURIComponent(tag);
	fetch(`${site_url}ajax/functions.php?operation=specialOnColumns&tag=${tag}`)
	.then(response => response.json())
	.then(data => {
		if( data.err == false ){
			container.innerHTML = data.html;
		}else{
			console.error(`Error when executing the call of specials in the ${container.id}.\n Message: ${data.err_msg}`);
		}
	})
	.catch(error => {
		console.error('Fetch error:', error);
	});
}

function specialOnColumns(){
	const ALL_SPECIALS_MODULES = document.querySelectorAll(`.js-specialsCol`);
	ALL_SPECIALS_MODULES.forEach( module => {
		const 	FILTER = module.querySelector(`.js-specialsCol_filter`),
			 	MODULE_MOUNT_SPECIALS = module.querySelector(`.js-specialsCol_inner`),
				STATE_FILTER = {
					tag: "All",
					container: MODULE_MOUNT_SPECIALS
				};
		
		if( FILTER ){
			FILTER.addEventListener("click", (event) => {
				let elementCLicked = event.target;
				if( elementCLicked.nodeName == "LI" ){
					if(FILTER.querySelector('.active'))
						FILTER.querySelector('.active').classList.remove('active');

					STATE_FILTER.tag = elementCLicked.dataset.tag;
					getAndMountSpecialsOnColumns(STATE_FILTER);

					elementCLicked.classList.add('active');
				}
			})
			
			FILTER.querySelector('li').click();
		}else{
			getAndMountSpecialsOnColumns(STATE_FILTER);
		}
	} )
}

window.addEventListener("load", (event) => {
	let sectionId = location.hash.substring(1);
	if( sectionId ){
		let sectionFromUrl = document.getElementById(sectionId);
		scrollToElementFn( sectionFromUrl );
	}

	let anchorsWithHash = document.querySelectorAll(`a.btn[href^="#"]:not([data-lbx]):not(.swiper):not([data-swiper])`);
	anchorsWithHash.forEach( anchor => {
		anchor.addEventListener( 'click', event => {
			let elementFromHrefHash = document.querySelector(`${anchor.hash}`);
			if( elementFromHrefHash ){
				event.preventDefault();
				scrollToElementFn( elementFromHrefHash );
			}
		} )
	} );

});